<template>
  <van-popup v-model="showCoupon" position="bottom" @close="closePopup">
    <div class="popup-top">
      <van-divider contentPosition="center" customStyle="color: #868686;">选择优惠劵</van-divider>
    </div>
    <div class="group-main">
      <van-tabs color="#C89884" tab-active-class="active-tab-coupon" animated>
        <van-tab title="可用优惠劵" >
          <div class="couponList flex-csc" v-if="couponList && couponList.length > 0">
            <van-radio-group v-model="setCouponId" @change="onChange" >
              <van-cell-group>
                <van-cell
                  clickable
                  :data-name="item.couponId"
                  @click="selectCoupon(item)"
                  v-for="(item, index) in couponList" :key="index"
                >
                  <div class="coupon-item flex-rsc">
                    <div class="left-content">
                      <div  class="money"><span>¥</span><span  class="number">{{item.amountStr}}</span></div>
                      <span class="text">满{{item.maxAmountStr}}可用</span>
                    </div>
                    <div class="right-content flex-1">
                      <div class="coupon-title">{{item.couponName}}</div>
                      <div class="flex-rbc">
                        <div class="time">{{item.dateStr}}</div>
                        <van-radio slot="right-icon" checked-color="#FA4E26" :name="item.couponId"></van-radio>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <div v-else>
            <no-data text="暂无可用优惠劵" type="coupon"></no-data>
          </div>
        </van-tab>
        <van-tab title="不可用优惠劵">
          <div class="couponList flex-csc" v-if="UnDiscountCoupon && UnDiscountCoupon.length > 0">
            <div class="coupon-item flex-rsc" v-for="(item, index) in UnDiscountCoupon" :key="index">
              <div class="left-content">
                <div  class="money"><span>¥</span><span  class="number">{{item.amountStr}}</span></div>
                <span class="text">满{{item.maxAmountStr}}可用</span>
              </div>
              <div class="right-content flex-1">
                <div class="coupon-title">{{item.couponName}}</div>
                <div class="flex-rbc">
                  <div class="time">{{item.dateStr}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <no-data text="暂无不可用优惠劵" type="coupon"></no-data>
          </div>
        </van-tab>
      </van-tabs>

    </div>
    <div class="popup-btn flex-ccc">
      <button class="button-default wx-button-primary" @click="changeProject">确定</button>
    </div>
  </van-popup>
</template>

<script>
  import noData from '@/components/coupon/noCoupon'
  import { Dialog } from 'vant';
  export default {
    props: ['couponList', 'showCoupon', 'setCouponId', 'setCashCouponArr', 'UnDiscountCoupon'],
    data () {
      return {
        mechInfo: {}
      }
    },
    components: {
      noData
    },
    methods: {
      onChangeTab ({mp}) {
        console.log('mp', mp)
      },
      onChange (e) {
        console.log('e', e)
        this.setCouponId = e
      },
      selectCoupon (item) {
        console.log('selectCoupon', item)
        // const { name } = mp.currentTarget.dataset
        // console.log('name', name)
        if (this.setCouponId === item.couponId.toString()) {
          this.setCouponId = ''
        } else {
          this.setCouponId = item.couponId.toString()
        }
      },
      closePopup () {
        this.$emit('closePopup')
      },
      changeProject () {
        if (!this.setCouponId) {
          this.$emit('closePopup')
          return
        }
        let filterArr = this.couponList.filter(item => item.couponId.toString() === this.setCouponId)
        let discountObj = filterArr[0]
        const {setCashCouponArr} = this
        console.log('setCashCouponArr', setCashCouponArr)
        if (setCashCouponArr && setCashCouponArr.length > 0) {
          Dialog.confirm({
            title: '标题',
            message: '优惠劵和代金劵不能同时使用，是否要放弃代金劵？'
          }).then(() => {
            // on confirm
            this.$emit('discountPopup', discountObj)
          }).catch(() => {
            // on cancel
            this.$emit('closePopup')
          })
        } else {
          this.$emit('discountPopup', discountObj)
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .popup-top
    padding 0 50px
  .group-main
    padding 5px 0
    overflow-y scroll
    height 260px
    .group-tit
      font-size 12px
      color $sixColor
    .van-checkbox
      padding 5px
      width 100%
    .artificer-list
      margin-top 10px
  .popup-btn
    padding 10px 20px
    overflow hidden
  .artificer
    padding-bottom 4px
    border 1px solid #fff
    &.active
      border 1px solid $blueColor
    margin-right 12px
    img
      width 72px
      height 90px
    .name
      text-align center
      font-size 14px
      color $blackColor
      line-height 2em
    .years
      text-align center
      font-size 12px
      color $grayColor
  >>>.van-checkbox__label
    width 80vw !important

.couponList
  width 100vw
  .coupon-item
    display: flex;
    flex-direction: row;
    width 325px
    height 94px
    background url("../../assets/images/coupon-bg.png") no-repeat
    background-size cover
    .left-content
      text-align center
      padding 10px
      width 30%
      .money
        font-weight 500
        text-align center
        font-size 34px
        color $redColor
        span
          font-size 23px
      .text
        padding 2px 4px
        font-size 10px
        background $blueColor
        border-radius 18px
        margin-top 7px
        color #fff
    .right-content
      padding 0 14px 0 4px
      .coupon-title
        font-size 14px
        font-weight 500
        color $blackColor
        text-align left
      .time
        font-size 12px
        color $grayColor
</style>
